module.exports = __webpack_public_path__ + "img/446d805.jpg";